import config from "../config/config.js";
import { getHeaders, handleResponse } from "./utils";

// Demo company ("Thousand Oaks Mortgage").
const DEMO_COMPANY_ID = 1;

/**
 * System Admin — demo-account management (clone per new hire, reassign on
 * departure). Backed by the /admin/* endpoints; all require an authed admin.
 */
const AdminService = {
  async listDemoAccounts() {
    const response = await fetch(
      config.serviceHost + "admin/demo-accounts/" + DEMO_COMPANY_ID,
      { method: "GET", headers: getHeaders() }
    );
    return handleResponse(response);
  },

  async cloneDemoAccount({
    firstName,
    lastName,
    email,
    password,
    templateEmail,
    assignedLender,
    isDemo
  }) {
    const data = new FormData();
    data.append("firstName", firstName || "");
    data.append("lastName", lastName || "");
    data.append("email", email || "");
    data.append("password", password || "");
    data.append("assignedLender", assignedLender || "");
    data.append("isDemo", isDemo ? "true" : "false");
    if (templateEmail) data.append("templateEmail", templateEmail);
    const response = await fetch(
      config.serviceHost + "admin/clone-demo-account/" + DEMO_COMPANY_ID,
      { method: "POST", headers: getHeaders(), body: data }
    );
    return handleResponse(response);
  },

  async reassignDemoAccount({
    userId,
    firstName,
    lastName,
    email,
    password,
    assignedLender,
    isDemo
  }) {
    const data = new FormData();
    data.append("userId", String(userId));
    data.append("firstName", firstName || "");
    data.append("lastName", lastName || "");
    data.append("email", email || "");
    data.append("password", password || "");
    data.append("assignedLender", assignedLender || "");
    data.append("isDemo", isDemo ? "true" : "false");
    const response = await fetch(config.serviceHost + "admin/reassign-demo-account", {
      method: "POST",
      headers: getHeaders(),
      body: data
    });
    return handleResponse(response);
  }
};

export default AdminService;
